(function() {
  const priceDataEl = document.getElementById('price-data');
  if (!priceDataEl) return;

  const productData = JSON.parse(priceDataEl.textContent);
  const sectionId = priceDataEl.getAttribute('data-section-id');

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2);
  }

  function updatePrice(variant) {
    const container = document.getElementById('price-container-' + sectionId);
    if (!variant || !container) return;
    let html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const savedAmount = variant.compare_at_price - variant.price;
      const savedPercent = Math.round((savedAmount / variant.compare_at_price) * 100);
      html += '<span class="price-compare" id="compare-price-' + sectionId + '">' + formatMoney(variant.compare_at_price) + '</span>';
      html += '<span class="price-sale" id="sale-price-' + sectionId + '">' + formatMoney(variant.price) + '</span>';
      html += '<span class="price-save" id="save-percent-' + sectionId + '">Save ' + savedPercent + '%</span>';
    } else {
      html += '<span class="price-regular" id="regular-price-' + sectionId + '">' + formatMoney(variant.price) + '</span>';
    }
    html += '<div class="price-tax-note">(Inc. All Taxes)</div>';
    container.innerHTML = html;
  }

  function getVariantFromUrl() {
    const variantId = new URL(window.location.href).searchParams.get('variant');
    if (!variantId) return null;
    return productData.variants.find(function(v) { return v.id == variantId; });
  }

  function getVariantFromForm() {
    const input = document.querySelector('form[action="/cart/add"] input[name="id"], form[action="/cart/add"] select[name="id"]');
    if (!input) return null;
    return productData.variants.find(function(v) { return v.id == input.value; });
  }

  let priceTimer;
  function debouncedUpdate() {
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function() {
      const variant = getVariantFromUrl() || getVariantFromForm();
      if (variant) updatePrice(variant);
    }, 80);
  }

  document.addEventListener('change', function(e) {
    if (e.target.name === 'id' || e.target.closest('form[action="/cart/add"]')) {
      debouncedUpdate();
    }
  });

  window.addEventListener('popstate', debouncedUpdate);
  document.addEventListener('variant:changed', debouncedUpdate);

})();